import React from 'react';


export default function Grow() {
    return (
        <div style={{flexGrow: 1}}/>
    )
}